"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum;
(function (TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum) {
    TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum["Read"] = "READ";
    TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum["Write"] = "WRITE";
    TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum["Delete"] = "DELETE";
    TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum["ChangeHierarchy"] = "CHANGE_HIERARCHY";
    TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum["ChangePermissions"] = "CHANGE_PERMISSIONS";
})(TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum = exports.TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum || (exports.TableauNlpLensMonolithserviceUserLensCapabilityCapabilityEnum = {}));
function TableauNlpLensMonolithserviceUserLensCapabilityFromJSON(json) {
    return TableauNlpLensMonolithserviceUserLensCapabilityFromJSONTyped(json, false);
}
exports.TableauNlpLensMonolithserviceUserLensCapabilityFromJSON = TableauNlpLensMonolithserviceUserLensCapabilityFromJSON;
function TableauNlpLensMonolithserviceUserLensCapabilityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'capability': !runtime_1.exists(json, 'capability') ? undefined : json['capability'],
        'isAllowed': !runtime_1.exists(json, 'is_allowed') ? undefined : json['is_allowed'],
    };
}
exports.TableauNlpLensMonolithserviceUserLensCapabilityFromJSONTyped = TableauNlpLensMonolithserviceUserLensCapabilityFromJSONTyped;
function TableauNlpLensMonolithserviceUserLensCapabilityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'capability': value.capability,
        'is_allowed': value.isAllowed,
    };
}
exports.TableauNlpLensMonolithserviceUserLensCapabilityToJSON = TableauNlpLensMonolithserviceUserLensCapabilityToJSON;
